module.exports = __webpack_public_path__ + "img/customize-images.2510dff7.jpg";